<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacaoExame"
                    :request-query-string-params="{tipo_id: enums.tipoExame.EXAME_LABORATORIAL}"
                    :search-fields="fields.conectasusExame"
                    label="Exame (ConectaSUS)"
                    uppercase
                    v-model="model.conectasusExame"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-select
                    :options="form.laboratorios"
                    :validations="validations.laboratorio"
                    label="Laboratório"
                    show-default-option
                    text-field="descricao"
                    v-model="model.laboratorioId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Enums.
import tipoExame from '@/enums/parametrizacao/tipoExame'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 200,
                },
                laboratorio: {required: true},
            }
        },
        fields() {
            return {
                conectasusExame: [
                    { key: 'parametrizacaoExame.codigo', searchable: true },
                    { key: 'parametrizacaoExame.nome', searchable: true },
                ],
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacaoExame: this.getConectaSusRepository('parametrizacao.exame'),
            exame: this.getConectaSusRepository('webService.laboratorio.cliente.exame'),
        }
    },
    data: () => ({
        form: null,
        model: null,
        enums: {tipoExame},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.exame.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.exame.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        nome: this.model.nome,
                        conectasusExameId: this.model.conectasusExame?.id ?? null,
                    }

                    if (this.id) {
                        this.repositories.exame.update(this.model.laboratorioId, this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.exame.store(this.model.laboratorioId, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>